import BaseAlgoliaSearch, { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { get } from 'lodash-es';
import { SearchOptions, SearchSettings } from '@module/Algolia/resources/js/search/types';
import {
  transformArticle,
  transformCollection,
  transformProduct,
  transformStore,
  transformUserManual,
} from './transformers';
import { SearchResult } from '@phoenix/search/interfaces/SearchResultTypes';
import { TAB_ALL } from '@maison/helpers/search-helper';

let instance: AlgoliaSearch | null = null;

export default class AlgoliaSearch extends BaseAlgoliaSearch {
  static getInstance(): AlgoliaSearch {
    if (!instance) {
      instance = new AlgoliaSearch();
    }

    return instance;
  }

  isAnalyticsEnabled(): boolean {
    return true;
  }

  protected getMainSearchSettings(): SearchSettings[] {
    return [
      ...super.getMainSearchSettings(),
      this.getServicesSettings(),
      this.getCollectionsSettings(),
      this.getUserManualsSettings(),
      this.getSuggestionsSettings(),
    ];
  }

  protected getProductsSettings(): SearchSettings {
    return {
      ...super.getProductsSettings(),
      transformer: transformProduct,
    };
  }

  protected getStoresSettings(): SearchSettings {
    return {
      ...super.getStoresSettings(),
      transformer: transformStore,
    };
  }

  protected getArticlesSettings(): SearchSettings {
    return {
      ...super.getArticlesSettings(),
      transformer: transformArticle,
    };
  }

  protected getServicesSettings(): SearchSettings {
    return {
      ...super.getServicesSettings(),
      transformer: transformArticle,
    };
  }

  protected getCollectionsSettings(): SearchSettings {
    return {
      name: 'collections',
      type: 'search',
      indexName: IndexNames.Collections,
      transformer: transformCollection,
      hitsPerPage: 1,
      analyticsTags: ['Collections'],
    };
  }

  protected getUserManualsSettings(): SearchSettings {
    return {
      name: 'userManuals',
      type: 'search',
      indexName: IndexNames.Products,
      transformer: transformUserManual,
      hitsPerPage: 24,
      activations: [],
      filters: {
        hasUserManuals: true,
      },
      analyticsTags: ['User Manuals'],
    };
  }

  async performMainSearch(query: string, tab: string = TAB_ALL, options?: SearchOptions): Promise<SearchResult> {
    const result = await super.performMainSearch(query, tab, options);

    if (result.type === 'aggregated' && result.results?.products) {
      result.results.products.suggestedCollection = get(result.results, ['collections', 'data', 0], null);
      delete result.results.collections;
    }

    return result;
  }
}

export const algoliaSearch = AlgoliaSearch.getInstance();
